import React, {useEffect,useState,useContext,useRef} from 'react'
import { GlobalContext } from '../contexts/GlobalContext';
import { formatDate,saveNewsItem, X_PADDING } from '../constants';
import { createRoot } from 'react-dom/client'
import Edit from './Edit';
import NewsForm from './NewsForm';
import { PiPlusBold } from 'react-icons/pi';

const AddNewsItem = ({size}) => {
    const {editing,version,setVersion} = useContext(GlobalContext);
    const addRef = useRef();

    const onAddNewsItem = async () => {
        return await saveNewsItem(addRef);
    }

    return (
        <div style={{width:size.width+'px'}}
            className='flex justify-center items-center h-72 bg-[rgb(247,247,247)] border border-[rgb(200,200,200)] border-dashed rounded-lg overflow-hidden'>
            <button onClick={(e) => {
                e.stopPropagation();
                const container = document.createElement("div");
                container.style.left = '0';
                container.style.top = '0';
                container.style.right = '0';
                container.style.bottom = '0'; 
                container.style.position = 'fixed';
                container.style.zIndex = 100;
                container.style.overflow = 'hidden';
                document.body.appendChild(container);

                // Create a new React root
                const root = createRoot(container);

                // Define cleanup function
                const close = () => {
                    root.unmount();
                    container.remove();
                    
                };
                // Render the component into the container
                root.render(<Edit 
                    title="Add News Item"
                    Dialog={() => <NewsForm ref={addRef} />} 
                    submit={onAddNewsItem} 
                    close={close} 
                    version={version} 
                    setVersion={setVersion}/>);
            }} 
                className='flex flex-col w-16 h-16 justify-center items-center border border-theme border-dashed rounded-lg'>
                <PiPlusBold size={32} className='text-theme'/>
            </button>
        </div>
    )
}

export default AddNewsItem